module.exports = __webpack_public_path__ + "img/teacher1.5a733210.png";